<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Site Not Available</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      background-color: #f8f9fa;
      text-align: center;
      padding: 50px;
    }
    .container {
      display: inline-block;
      text-align: left;
    }
    h1 {
      font-size: 2em;
      color: #333;
    }
    p {
      color: #666;
    }
    .error-code {
      color: #d9534f;
    }
  </style>
</head>
<body>
  <div class="container">
    <h1>This site can’t be reached</h1>
    <p>Check if there is a typo in the URL.</p>
    <p>If spelling is correct, try running Windows Network Diagnostics.</p>
    <p class="error-code">DNS_PROBE_FINISHED_NXDOMAIN</p>
  </div>
</body>
</html>